import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'notifications',
    props: true,
    component: () =>
      import(/* webpackChunkName: "notifications" */ './page.vue'),
    meta: {
      middleware: [loggedIn]
    },
    children: [
      {
        path: ':id',
        name: 'notificationsTableComponent',
        props: true,
        meta: {
          rootRouteName: 'notifications'
        },
        component: () =>
          import(
            /* webpackChunkName: "notificationsTableComponent" */ './item/index.vue'
          )
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'notifications' }
  }
];
